import React, {useEffect, useState} from "react";
import {connectHits} from "react-instantsearch-dom";
import Checkbox from "../Checkbox";
import {orderBy} from "lodash";

const Hits = ({hits}) => {

    const [hasCommunity, setHasCommunity] = React.useState(false);
    const [hasPros, setHasPros] = React.useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedPartners, setSelectedPartners] = useState([]);

    const p_array = ['Individuals', 'Companies', 'Manufacturers Suppliers'];
    const c_array = ['Community Members'];

    const currentItemRefinement = new Set();

    useEffect(() => {
        let p = hits.some(function (el) {
            console.log('ell', el);
            if (Array.isArray(el.directory_user_type)) {
                return p_array.some(v => el.directory_user_type.includes(v));
            }
            return p_array.includes(el.directory_user_type);
        });
        setHasPros(p);
        let c = hits.some(function (el) {
            return c_array.includes(el.directory_user_type);
        });
        setHasCommunity(c);

        if (hits.length > 0) {
            setIsLoading(false);
        } else {
            let timer = setTimeout(() => setIsLoading(false), 3000);
            return () => {
                clearTimeout(timer);
            };
        }

    });

    const community_members = hits.filter(h => h.directory_user_type === 'Community Members');

    let sortedItems = orderBy(hits, ['name'], ['asc']);
    sortedItems.map(s => {
      s.isToggled = false;
      return s;
    });

    const toggle = item => {  // update `currentItemRefinement` on toggle
        console.log('MATtoggle', item);

    };

    const togglePartner = item => {
        item.isToggled = true;
        let currentPartners = selectedPartners;
        console.log('currentPartners', selectedPartners);
        if (currentPartners.includes(item.name)) {
            const newPartnerList = currentPartners.filter(item => item !== item.name);
            setSelectedPartners(newPartnerList);
        } else {
            currentPartners.push(item.name);
            setSelectedPartners(currentPartners);
        }
        console.log('currentPartnersUpdate', selectedPartners);
        console.log('sortedItems', sortedItems);
    }

    const isPartnerToggled = item => {
        let currentPartners = selectedPartners;
        if (currentPartners.includes(item.name)) {
            console.log('dddd');
            return false;
        } else {
            console.log('Nooope');
            return false;
        }
    }


    return (
        <React.Fragment>
            <div className="section__recently-joined">
                <div className="widgets-recently-joined">
                    <div className="widgets__head">
                        <h3>Contact These Manufacturers & Suppliers</h3>
                    </div>

                    <div className="widgets__body">
                        <div className="widgets__items">
                            {sortedItems.map((hit, index) => {
                                return (
                                    <div key={hit.label + "-" + index} className={`widgets__item--3 widgets__item--1of3 ${isPartnerToggled(hit) ? 'widgets__item--3-hidden' : ''}`} onClick={() => {
                                                      togglePartner(hit)
                                                  }}>
                                        <div className="widget-recently-joined">
                                            <div className="widget__image">
                                                <img src={hit.directory_image} alt=""/>
                                            </div>

                                            <div className="widget__content">
                                                <h3>{hit.isToggled}
                                                    <a href="#">{hit.name}</a>
                                                </h3>


                                            </div>
                                        </div>
                                    </div>
                                )
                            })}


                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

const PartnerResultPanel = connectHits(Hits);
export default PartnerResultPanel;
